import { createAsyncAction, METHODS } from 'api';
import { MICROSERVICES_NAMES } from 'api/types';
import { USProductOfferDocument } from 'types';

export const fetchProductDocument = async (productId): Promise<USProductOfferDocument> => {
  try {
    const response = await createAsyncAction(
      'en-US',
      MICROSERVICES_NAMES.VARIFY,
      'varify.productTerms',
      METHODS.POST,
      {
        params: {
          query: `query getProductOfferDocument($productId: ID!) {
              productOfferDocument(id: $productId) {
                id
                content
              }
            }`,
          variables: { productId },
        },
      },
    );

    return response?.data?.productOfferDocument ?? {};
  } catch {
    return {};
  }
};
